import { render, staticRenderFns } from "./gardenModel1920.vue?vue&type=template&id=7f3e3d39&scoped=true&"
import script from "./gardenModel1920.vue?vue&type=script&lang=js&"
export * from "./gardenModel1920.vue?vue&type=script&lang=js&"
import style0 from "./gardenModel1920.vue?vue&type=style&index=0&id=7f3e3d39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e3d39",
  null
  
)

export default component.exports